export default {
      id: "revenue-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#revenue",
      toString: function () {
        return this.url;
      }
    }